import { DatePicker, InputNumber, Select } from 'antd'
import classnames from 'classnames'
import moment, { Moment } from 'moment'
import { Component, ReactNode } from 'react'
// import DatePicker from 'react-date-picker';
import { toast } from 'react-toastify'
import {
  AccountInfoDto,
  CurrentCompanyInfoInfoResponseDto,
  DISCOUNT_TYPE,
  PaymentTerm,
  PromoCodeUsed,
  ServiceDto
} from '../../../../definition'
import { BookingDto, BOOKING_TYPE, RecurringFrequency } from '../../../../definition/booking.dto'
import { NewQuoteDto, QUOTE_STATUS, Quote2ServiceDto, QuoteDto, UpdateQuoteDto } from '../../../../definition/quote.dto'
import { processLoading, appEventEmitter } from '../../../../initialization'
import { asyncGetCustomerDetail, asyncGetServices } from '../../../../services'
import { asyncGetStaticData } from '../../../../services/booking.service'
import {
  asyncCreateQuote,
  asyncGetQuoteDetail,
  asyncUpdateQuote,
  asyncSendQuote
} from '../../../../services/quote.service'
import { asyncGetCompanyInfor } from '../../../../services'
import { ModalNodeProps } from '../../../components/modal.component'
import { ModalNode } from '../../../components/modal.component'
import deleteIcon from './../../../../styles/images/delete-icon.png'
import plusIcon from './../../../../styles/images/plus-icon.png'
import QuoteCSV from './csv/quoteCSV'
import {
  getPaymentTermLlabel,
  getBase64FromUrl,
  checkIfServiceHavePromo,
  renderDiscountPromo,
  quoteCalculation,
  quoteLabel
} from '../../../../utils'
import jsPDF from 'jspdf'
import QuotePDF from './pdf/quotePDF'
import { APP_EVENTS, SWITCH_FUNCTION } from '../../../../constants'
import { CONTRACT_DURATION, CONTRACT_ONE_SERVICE, DURATION_1_YEAR } from '../../../../constants/booking.config'
import { MultiSericeDto } from '../booking/new-one-time-booking2'

export interface NewQuoteState {
  quoteId?: string
  quoteNo: string
  oldQuote?: QuoteDto

  customerId: string
  customerName: string

  date: Date
  dateError?: boolean

  serviceType: BOOKING_TYPE
  gst?: number
  booking?: BookingDto

  services?: Quote2ServiceDto[]
  serviceOptions: DropdownOptionProps[]
  serviceError?: boolean

  serviceList?: ServiceDto[]

  onSave?: (dto: NewQuoteDto) => Promise<void>
  onUpdate?: (dto: UpdateQuoteDto) => Promise<void>

  isNew: boolean
  isEditing: boolean

  editable?: boolean
  quoteTerms?: string
  serviceCharge?: number
  promoCodeUsed?: PromoCodeUsed
  surcharge?: number

  onetimeServiceId?: string
  recurringServices?: Quote2ServiceDto[]
  multiServices?: MultiSericeDto[]
  status?: QUOTE_STATUS
}

interface HashMap<T> {
  [key: string]: T
}

export interface DropdownOptionProps {
  value: string // Service Id
  label: string
  className?: string
}

export interface QuoteDetailPDF {
  customerName: string
  quoteNo: string
  serviceType: BOOKING_TYPE
  date: Date
  services?: Quote2ServiceDto[]
  quoteTerms?: string
  gst?: number
  paymentTerm?: PaymentTerm
  paymentTermValue?: number
  serviceOptions: DropdownOptionProps[]
  companyInfo?: CurrentCompanyInfoInfoResponseDto
  serviceCharge?: number | undefined
  customer?: AccountInfoDto
  promoCodeUsed?: PromoCodeUsed
  surcharge?: number
  booking?: BookingDto
}

export class NewQuoteModal extends Component<ModalNodeProps, NewQuoteState> {
  constructor(props: any) {
    super(props)
    const data = this.props.input
    this.state = {
      isNew: !data.quoteId,
      isEditing: !data.quoteId, // Default is new
      quoteId: data.quoteId,
      quoteNo: 'QTXXXX',
      customerId: data.customer.customerId,
      customerName: data.customer.customerName,
      date: new Date(),
      serviceType: data.serviceType,
      status: undefined,
      services: [
        {
          amount: 0,
          quantity: 1,
          discount: 0,
          durationInYears: 1,
          timesPerYear: data.serviceType === BOOKING_TYPE.RECURRING ? 4 : 1,
          discountType: DISCOUNT_TYPE.PERCENT
        }
      ],
      serviceOptions: [],
      editable: data.editable === undefined ? true : data.editable,
      promoCodeUsed: data.promoCodeUsed,
      surcharge: 0,
      onetimeServiceId: data.onetimeServiceId,
      recurringServices: data.recurringServices,
      multiServices: data.multiServices
    }

    this.state.customerId && this.doInit()
  }

  async doInit() {
    await processLoading(this.processInit())
  }

  async processInit() {
    const services = (await asyncGetServices({ all: true }))?.items
    const { gst, quote_term: quoteTerms, service_charge: serviceCharge } = await asyncGetStaticData()
    const quote = this.state.quoteId && (await asyncGetQuoteDetail(this.state.quoteId))
    if (this.state.quoteId && !quote) {
      toast.error(`The quote with [${this.state.quoteId}] is not found`)
      return
    }

    const serviceOptions: DropdownOptionProps[] = services.map((service) => ({
      value: service.id,
      label: service.name
    }))

    let quoteGST: number
    let quoteServiceCharge: number | undefined

    if (quote && this.state.quoteId) {
      quoteGST = quote.gst
      quoteServiceCharge = quote.serviceCharge
    } else {
      quoteGST = gst
      quoteServiceCharge = serviceCharge
    }

    this.setState({
      gst: quoteGST,
      quoteTerms,
      serviceCharge: quoteServiceCharge
    })
    if (serviceOptions && serviceOptions.length > 0) {
      this.setState({
        serviceList: services,
        serviceOptions: serviceOptions
      })
    } else {
      toast.warn(<>There is no service found!</>)
    }

    if (quote) {
      this.setState({
        oldQuote: quote,
        quoteNo: quote.code,
        date: moment(quote.createdAt).toDate(),
        serviceType: quote.bookingType,
        booking: quote.booking,
        services: quote.quoteToServices,
        promoCodeUsed: quote.booking?.promoCodeUsed,
        surcharge: quote.surcharge,
        status: quote.status
      })
    } else {
      if (this.state.serviceType === BOOKING_TYPE.ONE_TIME) {
        const hashMultiOnetime = this.getHashMultiServiceOnetime(this.state.multiServices)
        const findServiceInBooking = services
          .filter((service) => {
            if (SWITCH_FUNCTION.multi_onetime) {
              return hashMultiOnetime[service.id]
            } else {
              return service.id === this.state.onetimeServiceId
            }
          })
          .map((service) => {
            return {
              name: service.name,
              serviceId: service.id,
              amount: this.getSuggestPrice(service),
              quantity: 1,
              discount: 0,
              durationInYears: 1,
              timesPerYear: 1,
              discountType: DISCOUNT_TYPE.PERCENT
            }
          })
        this.setState({
          services: findServiceInBooking
        })
      } else if (this.state.serviceType === BOOKING_TYPE.RECURRING) {
        const hashRecurringServices = this.getHashRecurringServices(this.state.recurringServices)
        const findServiceInBooking = services
          .filter((service) => hashRecurringServices[service.id])
          .map((service) => {
            return {
              name: service.name,
              serviceId: service.id,
              amount: this.getSuggestPrice(service),
              quantity: 1,
              discount: 0,
              durationInYears: hashRecurringServices[service.id].durationInYears,
              timesPerYear: hashRecurringServices[service.id].timesPerYear,
              discountType: DISCOUNT_TYPE.PERCENT,
              frequency: hashRecurringServices[service.id].frequency
            }
          })
        this.setState({
          services: findServiceInBooking
        })
      }
    }
  }

  getHashRecurringServices = (recurringServices?: Quote2ServiceDto[]) => {
    const hashRecurring: HashMap<Quote2ServiceDto> = {}
    ;(recurringServices || []).forEach((service) => {
      if (service.serviceId) {
        hashRecurring[service.serviceId] = service
      }
    })
    return hashRecurring
  }

  getHashMultiServiceOnetime = (multiservices?: MultiSericeDto[]) => {
    const hashMultiOntime: HashMap<MultiSericeDto> = {}
    ;(multiservices || []).forEach((service) => {
      if (service.serviceId) {
        hashMultiOntime[service.serviceId] = service
      }
    })
    return hashMultiOntime
  }

  getSuggestPrice = (service: ServiceDto) => {
    let suggestAmount
    if (SWITCH_FUNCTION.config_price) {
      suggestAmount = this.state.serviceType === BOOKING_TYPE.RECURRING ? service.priceRecurring : service?.price
    } else {
      suggestAmount = service?.price
    }
    return suggestAmount || 0
  }

  onDonwload = (quoteId: string) => {
    toast.warning(<>[{quoteId}] View is not yet implemented!</>)
  }

  _validateServices = (services?: Quote2ServiceDto[]): boolean => {
    if (!services) return false
    for (const service of services) {
      if (
        !(
          service.serviceId &&
          service.amount >= 0 &&
          service.quantity > 0 &&
          service.discount >= 0 &&
          Number(service.timesPerYear) > 0 &&
          Number(service.durationInYears) > 0
        )
      ) {
        toast.error(<>Please check list services</>)
        return false
      }

      if (service.discountType === DISCOUNT_TYPE.FIXED) {
        if (service.discount > service.amount) {
          toast.error(<>Discount must {'<'} amount</>)
          return false
        }
      }

      if (Number(service.durationInYears) > 4) {
        toast.error(<>{`Contract Duration must be >=1 and <=4`}</>)
        return false
      }
    }
    return true
  }

  onAddNew = async () => {
    const valid = this._validateServices(this.state.services)
    if (!valid) return

    const dto: NewQuoteDto = {
      customerId: this.state.customerId,
      date: this.state.date,
      bookingType: this.state.serviceType,
      serviceSummaries: this.state.services,
      surcharge: this.state.surcharge
    }

    try {
      const res = await asyncCreateQuote(dto)
      this.state.onSave && this.state.onSave(dto)
      this.props.onDone?.({ ...res, quoteToServices: this.state.services })
    } catch (error: any) {
      const errMsg = error.response?.data?.error?.message || error.message
      console.error(errMsg)
      toast.error(<>{errMsg}</>)
    }
  }

  onUpdate = async () => {
    if (this.state.oldQuote) {
      const valid = this._validateServices(this.state.services)
      if (!valid) return

      const dto: UpdateQuoteDto = {
        customerId: this.state.customerId,
        date: this.state.date,
        bookingType: this.state.serviceType,
        serviceSummaries: this.state.services,
        surcharge: this.state.surcharge
      }

      try {
        this.state.quoteId && (await asyncUpdateQuote(this.state.quoteId, dto))
        this.state.onUpdate && this.state.onUpdate(dto)
        this.props.onDone?.({ ...dto, quoteToServices: this.state.services })
      } catch (error: any) {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      }
    }
  }

  onAddService = () => {
    this.state.services?.push({
      amount: 0,
      quantity: 1,
      discount: 0,
      durationInYears: 1,
      timesPerYear: this.state.serviceType === BOOKING_TYPE.RECURRING ? 4 : 1,
      discountType: DISCOUNT_TYPE.PERCENT
    })
    this.forceUpdate()
  }

  renderDiscountInput = (service: Quote2ServiceDto, index: number) => {
    if (this.state.promoCodeUsed && checkIfServiceHavePromo(this.state.promoCodeUsed, service.serviceId)) {
      return (
        <InputNumber
          value={this.state.promoCodeUsed.promoCode.discountValue}
          className={'small'}
          min={0}
          max={100}
          step={0.01}
          onChange={(number) => {
            const item = this.state.services?.[index]
            if (item) {
              item.discount = Number(number?.toFixed(2)) || 0
            }
            this.forceUpdate()
          }}
          readOnly={true}
        />
      )
    } else {
      return (
        <InputNumber
          value={service.discount}
          className={'small'}
          min={0}
          max={100}
          step={0.01}
          onChange={(number) => {
            const item = this.state.services?.[index]
            if (item) {
              item.discount = Number(number?.toFixed(2)) || 0
            }
            this.forceUpdate()
          }}
          readOnly={!this.state.isEditing}
        />
      )
    }
  }

  renderDiscountType = (service: Quote2ServiceDto, index: number) => {
    if (this.state.promoCodeUsed && checkIfServiceHavePromo(this.state.promoCodeUsed, service.serviceId)) {
      return (
        <Select
          options={[
            { value: DISCOUNT_TYPE.FIXED, label: '$' },
            { value: DISCOUNT_TYPE.PERCENT, label: '%' }
          ]}
          value={this.state.promoCodeUsed.promoCode.discountType}
          disabled={true}
        />
      )
    } else {
      return (
        <Select
          options={[
            { value: DISCOUNT_TYPE.FIXED, label: '$' },
            { value: DISCOUNT_TYPE.PERCENT, label: '%' }
          ]}
          value={service.discountType}
          onChange={(option) => {
            const item = this.state.services?.[index]
            if (item) {
              item.discountType = option
            }
            this.forceUpdate()
          }}
          disabled={!this.state.isEditing}
        />
      )
    }
  }

  filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

  renderServices = () => {
    return this.state.services?.map((service, index) => (
      <div className='services' key={index}>
        <div className='row'>
          <div className='column flex-width'>
            <div className='serviceName'>
              <label>Service Name</label>
              <div className='quote-service'>
                <Select
                  className='service-selection'
                  showSearch
                  allowClear
                  options={this.state.serviceOptions}
                  value={this.state.serviceOptions.find((option) => option.value === service.serviceId)?.label}
                  onSelect={(option: string) => {
                    const serviceSection = this.state.services?.[index]
                    if (serviceSection) {
                      const orgSer = this.state.serviceList?.find((service) => service.id === option)
                      serviceSection.service = orgSer
                      serviceSection.serviceId = serviceSection.service?.id
                      let suggestAmount
                      if (SWITCH_FUNCTION.config_price) {
                        suggestAmount =
                          this.state.serviceType === BOOKING_TYPE.RECURRING ? orgSer?.priceRecurring : orgSer?.price
                      } else {
                        suggestAmount = orgSer?.price
                      }
                      serviceSection.amount = suggestAmount || 0
                    }
                    this.forceUpdate()
                  }}
                  filterOption={this.filterOption}
                  disabled={!this.state.isEditing}
                  placeholder='Select A Service'
                />
              </div>
              <div className='row'>
                <div className='row'>
                  <div className='column flex-width'>
                    <div className='label-input'>
                      <label>Quantity</label>
                      <InputNumber
                        min={1}
                        value={service.quantity}
                        className={'small'}
                        onChange={(number) => {
                          const item = this.state.services?.[index]
                          if (item) {
                            item.quantity = parseInt(String(number)) || 0
                          }
                          this.forceUpdate()
                        }}
                        readOnly={!this.state.isEditing}
                        disabled={DURATION_1_YEAR}
                      />
                    </div>
                  </div>
                  <div className='column flex-width'>
                    <div className='label-input'>
                      <label>Amount($)</label>
                      <InputNumber
                        value={service.amount}
                        min={0}
                        step={0.01}
                        className={'small'}
                        onChange={(number) => {
                          const item = this.state.services?.[index]
                          if (item) {
                            item.amount = Number(number?.toFixed(2) || 0)
                          }
                          this.forceUpdate()
                        }}
                        readOnly={!this.state.isEditing}
                      />
                    </div>
                  </div>
                </div>

                <div className='column flex-width'>
                  <div className='label-input'>
                    {this.state.promoCodeUsed?.promoCode.discountType === DISCOUNT_TYPE.FIXED ? (
                      <label>Discount</label>
                    ) : (
                      <label>Discount per Qty</label>
                    )}
                    <div className='quote-discount'>
                      {this.renderDiscountType(service, index)}
                      {this.renderDiscountInput(service, index)}
                    </div>
                  </div>
                </div>
              </div>
              {this.renderFrequency(service)}
              {this.renderTimesDuration(service)}
            </div>
          </div>
          {/* <div className='column flex-width'>
            <div className='label-input' style={{ height: '100%' }}>
              <label>Service Description</label>
              <textarea value={service.service?.description} readOnly={true} />
            </div>
          </div> */}
          <div className='column flex-width'>
            <div className='label-input' style={{ height: '100%' }}>
              <label>Notes</label>
              <textarea
                value={service.notes}
                readOnly={!this.state.isEditing}
                onChange={(e) => {
                  const item = this.state.services?.[index]
                  if (item) {
                    item.notes = e.target.value
                  }
                  this.forceUpdate()
                }}
              />
            </div>
          </div>
          {this.state.isEditing && this.state.services?.length && this.state.services?.length > 1 && (
            <div
              onClick={() => {
                this.state.services?.splice(index, 1)
                this.forceUpdate()
              }}
            >
              <img
                src={deleteIcon}
                alt='Delete'
                onClick={() => {
                  this.state.services?.splice(index, 1)
                  this.forceUpdate()
                }}
              />
            </div>
          )}
        </div>
      </div>
    ))
  }

  renderTimesDuration = (service: Quote2ServiceDto) => {
    if (this.state.serviceType !== BOOKING_TYPE.RECURRING) {
      return undefined
    }
    return (
      <div className='row'>
        <div className='column flex-width'>
          <div className='label-input'>
            <label>Number Of Times Per {CONTRACT_DURATION}</label>
            <InputNumber
              value={service.timesPerYear}
              onChange={(value) => {
                const timesPerYear = Number(value?.toFixed(0) || 0)
                service.timesPerYear = timesPerYear
                this.forceUpdate()
              }}
              placeholder={`Number Of Times Per ${CONTRACT_DURATION}`}
              disabled={!this.state.isEditing || SWITCH_FUNCTION.service_booking_type}
            />
          </div>
        </div>
        <div className='column flex-width'>
          <div className='label-input'>
            <label>{`Contract Duration (${CONTRACT_DURATION}s)`}</label>
            <InputNumber
              value={service.durationInYears}
              onChange={(value) => {
                const durationInYears = Number(value?.toFixed(0) || 0)
                service.durationInYears = durationInYears
                this.forceUpdate()
              }}
              placeholder={'Contract Duration'}
              disabled={!this.state.isEditing || DURATION_1_YEAR}
            />
          </div>
        </div>
      </div>
    )
  }

  renderFrequency = (service: Quote2ServiceDto) => {
    if (this.state.serviceType !== BOOKING_TYPE.RECURRING || !SWITCH_FUNCTION.contract_frequency) {
      return undefined
    }
    return (
      <div className='row'>
        <div className='column flex-width'>
          <div className='label-input'>
            <label>Frequency</label>
            <Select
              value={service.frequency}
              options={[
                { value: RecurringFrequency.BiWeekly, label: 'Bi Weekly' },
                { value: RecurringFrequency.Weekly, label: 'Weekly' }
              ]}
              onChange={(value) => {
                service.frequency = value
                this.forceUpdate()
              }}
              disabled={!this.state.isEditing}
              placeholder='Select frequency'
            />
          </div>
        </div>
      </div>
    )
  }

  renderSavingButtons() {
    if (this.state.isNew) {
      return (
        <div
          className='action-button'
          onClick={async () => {
            await processLoading(this.onAddNew())
          }}
        >
          <button className='primary'>Attach {quoteLabel()}</button>
        </div>
      )
    } else if (!this.state.editable) {
      return (
        <div className='action-button'>
          <button
            className='primary'
            onClick={() => {
              this.props.onClose?.()
            }}
          >
            Close
          </button>
        </div>
      )
    } else {
      return (
        <div
          className='action-button'
          onClick={async () => {
            if (this.state.isEditing) {
              await processLoading(this.onUpdate())
            } else {
              this.setState({
                isEditing: true
              })
            }
          }}
        >
          <button className='primary' disabled={!this.state.editable}>
            {this.state.isEditing ? 'Save' : 'Edit'}
          </button>
        </div>
      )
    }
  }

  onChangeDate(selectedDate: Moment | null) {
    if (selectedDate) {
      this.setState({
        date: selectedDate?.toDate(),
        dateError: false
      })
    }
  }

  render(): ReactNode {
    const { subTotal, totalDiscount, amountAfterDiscount, totalTax, finalTotal } = quoteCalculation({
      services: this.state.services,
      promoCodeUsed: this.state.promoCodeUsed,
      gst: this.state.gst,
      surcharge: this.state.surcharge,
      serviceCharge: this.state.serviceCharge
    })

    const quoteSumUp = {
      customerName: this.state.customerName,
      quote: this.state.quoteNo,
      serviceType: this.state.serviceType,
      date: this.state.date,
      subtotal: subTotal.toFixed(2),
      discount: totalDiscount.toFixed(2),
      amountAfterDiscount: amountAfterDiscount.toFixed(2),
      gst: this.state.gst,
      gstVal: totalTax.toFixed(2),
      total: finalTotal.toFixed(2),
      paymentTermValue: this.state.booking?.paymentTermValue,
      paymentTerm: this.state.booking?.paymentTerm,
      paymentMethodPre: this.state.booking?.paymentMethodPre,
      serviceCharge: this.state.serviceCharge,
      promoCodeUsed: this.state.promoCodeUsed as PromoCodeUsed,
      surcharge: this.state.surcharge
    }

    const renderPaymentTermValeLabel = () => {
      if (this.state.booking?.paymentTerm === PaymentTerm.CREDIT) {
        return 'Duration (Days)'
      }
      if (this.state.booking?.paymentTerm === PaymentTerm.PPP) {
        return 'Partial Payment Percentage(%)'
      }
    }

    const printPDF = async (sent?: boolean) => {
      setTimeout(async () => {
        let modalSection
        if (SWITCH_FUNCTION.pdf_ver2) {
          modalSection = document.querySelector('.quote-detail-pdf-ver2')
        } else {
          modalSection = document.querySelector('.quote-detail-pdf')
        }
        const pdf = new jsPDF('p', 'mm', 'a4')
        pdf.html(modalSection as HTMLElement, {
          callback: (doc) => {
            if (!sent) {
              doc.save(`${this.state.quoteNo}.pdf`)
            } else {
              const file = doc.output('dataurlstring')
              if (this.state.quoteId) {
                asyncSendQuote(this.state.quoteId, file)
                  .then(() => {
                    toast.success('Success send quote details')
                  })
                  .catch(() => {
                    toast.error('Fail to sent quote detail, try later')
                  })
              }
            }
          },
          x: 0,
          y: 0,
          width: 210,
          windowWidth: 1440
        })
      }, 1000)
    }

    const onViewPDF = async (sent?: boolean) => {
      asyncGetCompanyInfor()
        .then(async (companyInfo: CurrentCompanyInfoInfoResponseDto) => {
          const logoBase64 = await getBase64FromUrl(companyInfo.logo)
          return { ...companyInfo, logo: logoBase64 }
        })
        .then(async (companyInfo) => {
          let customer
          if (this.state.customerId) {
            customer = await asyncGetCustomerDetail(this.state.customerId)
          }
          appEventEmitter.emit<ModalNode<QuoteDetailPDF>>(APP_EVENTS.app_modal, {
            input: {
              customerName: this.state.customerName,
              quoteNo: this.state.quoteNo,
              serviceType: this.state.serviceType,
              date: this.state.date,
              services: this.state.services,
              quoteTerms: this.state.quoteTerms,
              gst: this.state.gst,
              paymentTerm: this.state.booking?.paymentTerm,
              paymentTermValue: this.state.booking?.paymentTermValue,
              serviceOptions: this.state.serviceOptions,
              companyInfo: companyInfo as CurrentCompanyInfoInfoResponseDto,
              serviceCharge: this.state.serviceCharge,
              customer: customer as AccountInfoDto,
              promoCodeUsed: this.state.promoCodeUsed,
              surcharge: this.state.surcharge,
              booking: this.state.booking
            },
            status: true,
            node: QuotePDF,
            title: this.state.quoteNo,
            onClose: () => {}
          })
        })
        .then(() => {
          if (!sent) {
            printPDF()
          } else {
            printPDF(true)
          }
        })
    }

    const renderSurcharge = () => {
      if (!SWITCH_FUNCTION.surcharge) {
        return null
      }
      if (this.state.editable) {
        return (
          <div className='price-line quote-add-surcharge'>
            <div>Surcharge</div>
            <InputNumber
              formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              value={this.state.surcharge}
              min={0}
              step={0.01}
              className={'small'}
              onChange={(number) => {
                if (typeof number === 'number') {
                  this.setState({ surcharge: number })
                }
              }}
              disabled={!this.state.isEditing}
            />
          </div>
        )
      } else {
        if (this.state.surcharge) {
          return (
            <div className='price-line'>
              <div>Surcharge</div>
              <div className='value'>${this.state.surcharge.toFixed(2)}</div>
            </div>
          )
        } else {
          return null
        }
      }
    }

    return (
      <div className='create-quote-modal'>
        <div className='row'>
          <div className='column'>
            <div className='label-input'>
              <label>Customer Name</label>
              <input value={this.state.customerName} readOnly={true} />
            </div>
          </div>

          {!SWITCH_FUNCTION.remove_quote_from_flow && (
            <div className={classnames('column', 'fix-content')}>
              <div className='label-input center'>
                <label>Quote</label>
                <input value={this.state.quoteNo} readOnly={true} />
              </div>
            </div>
          )}
          {this.state.booking?.paymentTerm && (
            <div className={classnames('column', 'fix-content')}>
              <div className='label-input center'>
                <label>Payment Terms</label>
                <input value={getPaymentTermLlabel(this.state.booking?.paymentTerm)} readOnly={true} />
              </div>
            </div>
          )}
          {(this.state.booking?.paymentTerm === PaymentTerm.CREDIT ||
            this.state.booking?.paymentTerm === PaymentTerm.PPP) && (
            <div className={classnames('column', 'fix-content')}>
              <div className='label-input center'>
                <label>{renderPaymentTermValeLabel()}</label>
                <input value={this.state.booking?.paymentTermValue} readOnly={true} />
              </div>
            </div>
          )}
        </div>

        <div className='row'>
          <div className={classnames('column', 'fix-content')}>
            <div className='label-input'>
              <label>Date</label>
              <DatePicker
                disabled={true}
                className={`date-time-picker ${this.state.dateError ? 'input-error' : ''}`}
                value={moment(this.state.date)}
                format='DD/MM/YYYY'
                onChange={this.onChangeDate.bind(this)}
              />
              {/* <DatePicker
                className={[
                  'date-time-picker',
                  this.state.dateError ? 'input-error' : '',
                ]}
                onChange={(newDate: Date) =>
                  this.setState({
                    date: newDate,
                    dateError: false,
                  })
                }
                value={this.state.date}
                format={'dd/MM/yyyy'}
              /> */}
            </div>
          </div>

          <div className={classnames('column', 'fix-content')}>
            <div className='label-input center'>
              <label>Service Type</label>
              <input value={this.state.serviceType} readOnly={true} />
            </div>
          </div>

          {this.state.booking && (
            <div className={classnames('column', 'fix-content')}>
              <div className='label-input center'>
                <label>Booking Attached</label>
                <div
                  className='link'
                  onClick={() => {
                    const href =
                      this.state.booking?.type === BOOKING_TYPE.ONE_TIME
                        ? `/schedule/one-time-booking?bookingId=${this.state.booking?.id}`
                        : `/schedule/contract-booking?bookingId=${this.state.booking?.id}`
                    document.location.href = href
                  }}
                >
                  View Booking {this.state.booking?.code} {'>'}
                </div>
              </div>
            </div>
          )}
        </div>

        {this.renderServices()}

        {!CONTRACT_ONE_SERVICE && this.state.isEditing ? (
          <div className='row'>
            <div className='column'>
              <div className='add-more-service'>
                <img src={plusIcon} alt='Add more service' onClick={this.onAddService} />
                <span>Add New Service</span>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}

        <div className='row'>
          <div className='column column-2 flex-width'>
            <div className='title'>Terms</div>
            <div className='term' style={{ whiteSpace: 'pre-line' }}>
              {this.state.quoteTerms}
            </div>
          </div>
          <div className='column flex-width'>
            <div className='wrapper'>
              <div className='total'>
                <div className='price-line'>
                  <div>Subtotal</div>
                  <div className='value'>${subTotal.toFixed(2)}</div>
                </div>
                <div className='price-line'>
                  <div>Discount{renderDiscountPromo(this.state.promoCodeUsed)}</div>
                  <div className='value'>${totalDiscount.toFixed(2)}</div>
                </div>
                {totalTax > 0 && (
                  <div className='price-line'>
                    <div>Amount after discount</div>
                    <div className='value'>${amountAfterDiscount.toFixed(2)}</div>
                  </div>
                )}
                {renderSurcharge()}
                {this.state.serviceCharge ? (
                  <div className='price-line'>
                    <div>Platform Fee</div>
                    <div className='value'>${this.state.serviceCharge.toFixed(2)}</div>
                  </div>
                ) : null}
                {totalTax > 0 && (
                  <div className='price-line'>
                    <div>GST {this.state.gst}%</div>
                    <div className='value'>${totalTax.toFixed(2)}</div>
                  </div>
                )}
                <div className='separator' />
                <div className='price-line total-price'>
                  <div>Total</div>
                  <div className='value'>{finalTotal.toFixed(2)}</div>
                </div>
                <div className='separator' />
                <div className='separator' />
                {this.state.status && this.state.status !== QUOTE_STATUS.CREATED && (
                  <>
                    <div className='send-detail-btn'>
                      <button className='primary' onClick={() => onViewPDF(true)}>
                        Send Quote Details
                      </button>
                    </div>
                    <div className='download-csv-btn'>
                      <QuoteCSV
                        quoteSumUp={quoteSumUp}
                        services={this.state.services}
                        serviceOptions={this.state.serviceOptions}
                      />
                      OR
                      <button onClick={() => onViewPDF()}>Download PDF</button>
                    </div>
                  </>
                )}
                {this.renderSavingButtons()}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
